import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { portalApi } from '../../../../lib/portalApi';

const STATUS_COLOR = {
  pending: 'bg-amber-500/20 text-amber-300',
  under_review: 'bg-sky-500/20 text-sky-300',
  accepted: 'bg-emerald-500/20 text-emerald-300',
  rejected: 'bg-red-500/20 text-red-300',
};

export default function ApplicationsPage() {
  const [apps, setApps] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    portalApi
      .listApplications(filter || undefined)
      .then(setApps)
      .catch(() => setApps([]))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold text-white">Applications</h1>
          <p className="text-white/50 text-sm">Pending applications only, no startup until accept.</p>
        </div>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="bg-black/40 border border-white/10 rounded-xl px-3 py-2 text-white text-sm"
        >
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="under_review">Under review</option>
          <option value="accepted">Accepted</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>

      {loading ? (
        <p className="text-white/40">Loading…</p>
      ) : apps.length === 0 ? (
        <p className="text-white/40">No applications yet.</p>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-white/10">
          <table className="w-full text-sm">
            <thead className="bg-white/[0.04] text-white/50 text-left">
              <tr>
                <th className="px-4 py-3">Company</th>
                <th className="px-4 py-3">Founder</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">Submitted</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody>
              {apps.map((a) => (
                <tr key={a.id} className="border-t border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 text-white font-medium">{a.companyName}</td>
                  <td className="px-4 py-3 text-white/70">
                    {a.fullName}
                    <div className="text-xs text-white/40">{a.businessEmail}</div>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded-lg text-xs ${STATUS_COLOR[a.status] || 'bg-white/10 text-white/60'}`}>
                      {a.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-white/40">
                    {a.createdAt ? new Date(a.createdAt).toLocaleDateString() : '-'}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Link to={`/admin/applications/${a.id}`} className="text-[#ff8ec5] hover:underline">
                      Review
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
